import template from "./library-costs-page.html";

const LibraryCostsPageComponent = {
  template: template,
  controller: class CostListViewController {
    /* @ngInject */
    constructor(
      $rootScope,
      $q,
      $filter,
      Cost,
      ModalsManager,
      Notification,
      SweetAlertService,
      Utils
    ) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.$q = $q;
      this.Cost = Cost;
      this.ModalsManager = ModalsManager;
      this.NotificationService = Notification;
      this.SweetAlertService = SweetAlertService;
      this.Utils = Utils;
    }

    async $onInit() {
      this.costs = [];
      this.costsCount = 0;
      this.searchOptions = { name: "", page: 1 };
      this.newCostFormOpened = false;

      const { user, organization } = this.$rootScope;
      this.isAdmin = organization.isUserAdmin(user.id);

      await this.refresh();
      this.$rootScope.$applyAsync();

      this.$rootScope.$watch(
        () => this.searchOptions.name,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            if (newVal.length === 0) this.refresh().then();
            else this.findBySearchText().then();
          }
        }
      );
    }

    async findBySearchText() {
      this.loading = true;
      this.searchOptions = { name: this.searchOptions.name, page: 1 };
      const data = await this.$q
        .all({
          costPromise: this.Cost.query({
            q: this.searchOptions.name,
            page: this.searchOptions.page,
          }),
          costsCountPromise: this.Cost.getCount({ q: this.searchOptions.name }),
        })
        .then((values) => {
          return {
            costs: values.costPromise,
            costsCount: values.costsCountPromise,
          };
        });
      this.costs = data.costs;
      this.costsCount = data.costsCount;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async refresh() {
      this.searchOptions.name = "";
      await this.findBySearchText();
    }

    async loadMoreCosts() {
      const loadedCosts = this.costs.length;
      const costsToLoad = this.costsCount;
      if (loadedCosts < costsToLoad && !this.loading) {
        this.searchOptions.page++;
        const costs = await this.loadCosts();
        this.costs = this.costs.concat(costs);
        this.$rootScope.$applyAsync();
      }
    }

    async loadCosts() {
      this.loading = true;
      const costs = await this.Cost.query({
        q: this.searchOptions.name,
        page: this.searchOptions.page,
      });

      this.loading = false;
      this.$rootScope.$applyAsync();
      return costs;
    }

    async createCost() {
      if (await this.ModalsManager.openCostModal(new this.Cost()))
        await this.refresh();
    }

    async editCost(cost) {
      if (await this.ModalsManager.openCostModal(cost)) await this.refresh();
    }

    openNewCostForm() {
      this.newCost = new this.Cost();
      this.newCostFormOpened = true;
    }

    closeNewCostForm() {
      this.newCostFormOpened = false;
    }

    async onCostSaved() {
      this.newCostFormOpened = false;
      await this.refresh();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.tariffSaved"
        ),
      });
    }

    async deleteCost(cost) {
      if (!(await this.SweetAlertService.costAssociatedToTariffs())) return;

      await cost.delete();
      await this.refresh();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.costDeleted"
        ),
      });
    }

    async downloadCsv() {
      const organization = this.$rootScope.organization;

      const { csv } = await this.Cost.exportCsv();
      this.Utils.downloadCsv(
        csv,
        `${organization.name}-costs-${new Date().toJSON().slice(0, 10)}.csv`
      );
    }

    async openImportCostsCsvModal() {
      await this.ModalsManager.openImportCostsCsvModal();
      await this.refresh();
    }
  },
};

export default LibraryCostsPageComponent;
